import { useEffect } from "react";

export function useCenteredAnchors() {
  useEffect(() => {
    // scroll lisse global
    document.documentElement.style.scrollBehavior = "smooth";

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;

      const hash = a.getAttribute("href");
      const id = decodeURIComponent(hash.slice(1));
      const target = document.getElementById(id);
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "center" });
      window.history.pushState(null, "", hash);
    };

    const centerHash = () => {
      if (!window.location.hash) return;
      const id = decodeURIComponent(window.location.hash.slice(1));
      const target = document.getElementById(id);
      if (!target) return;
      requestAnimationFrame(() =>
        target.scrollIntoView({ behavior: "smooth", block: "center" })
      );
    };

    document.addEventListener("click", onClick);
    window.addEventListener("hashchange", centerHash);
    // centre si on arrive déjà avec un hash
    centerHash();

    return () => {
      document.removeEventListener("click", onClick);
      window.removeEventListener("hashchange", centerHash);
    };
  }, []);
}
